import React from 'react';
import { Card, CardProps } from '../../../../../CommonComponents/OPL/Card/Card';
import { CARDS_WIDTH } from '../../CharitableGiving.meta';

export const StepCard: React.FC<CardProps> = props => {
  return <Card maxWidth={CARDS_WIDTH} p="32" mx="auto" {...props} />;
};
